const createBreadcrumb = (articleTitle = "Content Article") => [
  { name: "Dashboard", link: "/" },
  { name: `${articleTitle}`, active: false },
];

export { createBreadcrumb };
